import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../../../../components/Link/Link';
import Image from '../../../../../components/Image';
import s from './CricketPlayerCard.scss';

const CricketPlayerCard = props => {
  const { items, playerkey, thumbslist, defaultThumb, statsId } = props;
  return (
    <div className={s.player_details}>
      <div className={s.player_image}>
        <Link to={`https://timesofindia.indiatimes.com/topic/${playerkey}`}>
          {thumbslist &&
          thumbslist[playerkey] &&
          thumbslist[playerkey].strimg ? (
            <Image
              key={thumbslist[playerkey].playernameseo}
              src={thumbslist[playerkey].strimg}
              placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
              alt={thumbslist[playerkey].playernameseo}
              lazyload
              offsetVertical={200}
            />
          ) : (
            <Image
              key="default_1"
              src={defaultThumb}
              placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
              alt="default"
              lazyload
              offsetVertical={200}
            />
          )}
        </Link>
      </div>
      {/* <div className={s.bg_box} /> */}
      {items &&
        items.short_name && (
          <div className={s.player_img}>{items.short_name}</div>
        )}
      {items &&
        items.skill_name && (
          <div className={s.player_position}>{items.skill_name}</div>
        )}
      {items &&
        items.top_score && (
          <div className={s.player_top_score}>
            {items.top_score}
            {items.skill_name && items.skill_name.toLowerCase() === 'batting'
              ? ' Runs'
              : ' Wickets'}
          </div>
        )}
      {(statsId === 2 ||
        statsId === '2' ||
        statsId === 13 ||
        statsId === '13') &&
        items.player_name && (
          <div className={s.player_name}>{items.player_name}</div>
        )}
      {items &&
        (statsId === 2 || statsId === '2') &&
        items.runs_scored && <div className={s.runs}>{items.runs_scored}</div>}
      {items &&
        (statsId === 13 || statsId === '13') &&
        items.wickets && <div className={s.runs}>{items.wickets}</div>}
      {items &&
        (statsId === 2 || statsId === '2') &&
        items.innings_played && (
          <div className={s.inn}>{`Innings: ${items.innings_played}`}</div>
        )}
      {items &&
        (statsId === 2 || statsId === '2') &&
        items.average && (
          <div className={s.avg}>{`Average: ${items.average}`}</div>
        )}
      {items &&
        (statsId === 13 || statsId === '13') &&
        items.matches_played && (
          <div className={s.inn}>{`Innings: ${items.innings}`}</div>
        )}
      {items &&
        (statsId === 13 || statsId === '13') &&
        items.best_bowling_average && (
          <div className={s.avg}>{`Average: ${
            items.best_bowling_average
          }`}</div>
        )}
    </div>
  );
};
CricketPlayerCard.propTypes = {
  items: PropTypes.objectOf({}),
  playerkey: PropTypes.string,
  thumbslist: PropTypes.objectOf({}),
  defaultThumb: PropTypes.string,
  statsId: PropTypes.number,
};
CricketPlayerCard.defaultProps = {
  items: {},
  playerkey: '',
  thumbslist: {},
  defaultThumb: '',
  statsId: 0,
};
export default CricketPlayerCard;
